import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Scroll from 'react-scroll'
import { Link } from "react-router-dom";
import AnimatedNumber from 'react-animated-number';
import Axios from 'axios';
import './index.scss';

// utils
// import CountiesTownsData from '../../config/CountiesTownsData';
import LoginMask from '../../utils/LoginMask';
import LoadingDots from '../../utils/LoadingDots';
import CustomSelect from '../../utils/CustomSelect';
import LimitMask from '../../utils/LimitMask';

// methods
import gaTracking from '../../utils/Shared/gaTracking';
import { apiHost, sourceHost } from '../../utils/Shared/constant';
import { loginRedirect, transferHundredPoint } from '../../utils/Shared/methods';

import spaceSuccessSvg from '../../../images/space-success.svg';
import spaceAlertSvg from '../../../images/space-alert.svg';
import CustomMsgMask from '../../utils/CustomMsgMask';
import spinnerGif from '../../../images/Spinner.gif';
import { mathMod } from 'ramda';

class EvacuationEstimate extends Component {
	// 統一判斷數值是否需要縮小字體的函數
	getValueClassName = (value) => {
		const length = (value + '').length;
		if (length >= 7) {
			return 'type-text -en value -md';  // 7位數以上用 -sm
		} else if (length >= 6) {
			return 'type-text -en value -lg';  // 6位數用 -lg
		}
		return 'type-text -en value';  // 5位數以下保持原大小
	};

	constructor(params) {
		super(params);
		this.state = {
			isMemberLogin: true,
			isBelowMinimumCount: false,
			isFirstTake: true,
			currentCounty: '縣市',
			currentTown: '鄉鎮',
			countiesTownsData: null,
			selectedCounty: null,
			selectedTown: null,
			selectedVillage: null,
			evacuateTopics: {
				evacuate: { name: '依歷史撤離人口', slug: 'Evacuate', active: false },
				potential: { name: '依潛勢人口', slug: 'Potential', active: false },
			},
			isEvacuateSelected: false,
			evacuateData: {
				Value: 0,
				Max: 0,
				valueRatio: null,
				maxRatio: null,
				loadFail: false,
				elderlyOccupiedHousingRatio: null,//僅老年人口居住宅數比率
				disabledPeopleRatio: null,//身心障礙者人口比率
				welfareInstitutionTotal: null,//社福機構數量
				totalEstimatedPowerLow: null,//預估開設所需人力(下限)
				totalEstimatedPowerHigh: null,//預估開設所需人力(上限)					
			},
			containTopics: {
				evacuate: { name: '依歷史收容人口', slug: 'Contain', active: false, isFirstTake: true },
				potential: { name: '依潛勢人口', slug: 'Potential', active: false, isFirstTake: true },
				custom: { name: '自訂撤離人口', slug: 'Custom', active: false, value: 0, isFirstTake: true },
			},
			isContainSelected: false,
			containRateFunction: {
				A: { name: '依調查數據估計', slug: 'A', active: false },
				B: { name: '依歷史收容率估計', slug: 'B', active: false },
			},
			isContainRateFuncSelected: false,
			containData: {
				Max: null,
				Ratio: null,
				Value: null,
				maxRatio: null,
				loadFail: false,
				elderlyOccupiedHousingRatio: null,//僅老年人口居住宅數比率
				disabledPeopleRatio: null,//身心障礙者人口比率
				welfareInstitutionTotal: null,//社福機構數量
				//totalEstimatedPowerLow: null,//預估開設所需人力(下限)
				//totalEstimatedPowerHigh: null,//預估開設所需人力(上限)			
			},
			spaceCustomNumber: 0,
			isSpaceDataLoaded: false,
			spaceData: {
				reality: 0,
				require: 0
			},
			materialTopics: {
				mountain: { name: '14 天（山區、易形成孤島地區建議儲備天數）', slug: '1', active: false },
				country: { name: '3 天（鄉村、偏遠地區建議儲備天數）', slug: '2', active: false },
				city: { name: '2 天（都會、半都會地區建議儲備天數）', slug: '3', active: false },
				custom:{ name:'自訂收容天數', slug:'-1', active:false, value: 0}
			},
			isMaterialSelected: false,
			isMaterialAdvance: false,
			isMaterialDataSubmitted: false,
			materialOptions: [],
			prevScrollY: 0,
			selectedPotentialRange: null,
			potentialRange: ["200", "350", "500", "650"],
			EstimateContainDTO: {
				County: null,
				Town: null,
				Village: null,
				FunctionType: null,
				RateFuncType: null,
				Evacuate: null,
				PotentialRange: null
			},
			EstimateEvacuateDTO: {
				County: null,
				Town: null,
				Village: null,
				FunctionType: null,
				PotentialRange: null
			},
			EstimateSpaceDTO: {
				County: null,
				Town: null,
				Village: null,
				Contain: null
			},
			EstimateMaterialDTO: {
				County: null,
				Town: null,
				Village: null,
				Contain: null,
				Locate: null,
				Custom: null
			}
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onLoadHeaderColor('PINK');
		this.props.onLoadHeaderTheme('DARK');
		this.props.onLoadShowLanguage('HIDE');
		const breadcrumb = [
			{ name: '首頁', href: '/' },
			{ name: '撤離與收容評估', href: '/evaluation/evacuation' },
			{ name: '撤離與收容人數及物資估計', href: '/evaluation/evacuation/estimate' },
		]
		this.props.onLoadShowBreadcrumb('SHOW', breadcrumb);
		this.getAvailableCounty();
		this.checkMemberLogin();
		this.getLocationType();
		window.addEventListener('scroll', this.handleScrollFixed);
	}
	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScrollFixed);
	}
	checkMemberLogin = () => {
		if (!window.localStorage.getItem('user-token')) {
			this.setState({ isMemberLogin: false });
		}
	}
	getAvailableCounty = () => {
		// Axios.get('/config/CountiesTownsVillagesData.json')
		Axios.get(`${apiHost}/api/Setting/GetCountiesTownsVillagesData`)
			.then(result => {
				const townAll = { code: '999', town: '全選', villages: [] };//鄉鎮全選
				result.data.counties.forEach((d) => {
					d.towns.unshift(townAll);
				})
				this.setState({ countiesTownsData: result.data });
			})
	}

	getLocationType = () => {
		const { materialTopics } = this.state;
		Axios.get(`${apiHost}/api/Estimate/GetLocationType`)
			.then(result => {
				result.data.forEach((d) => {
					switch (d.location_type) {
						case '都會、半都會地區':
							materialTopics.city.name = `${d.location_rate}天（${d.location_type}建議儲備天數）`;
							break;
						case '山區、易成孤島地區':
							materialTopics.mountain.name = `${d.location_rate}天（${d.location_type}建議儲備天數）`;
							break;
						case '鄉村、偏遠地區':
							materialTopics.country.name = `${d.location_rate}天（${d.location_type}建議儲備天數）`;
							break;
						default:
							break;
					}
				});
				this.setState({ materialTopics: materialTopics });
			})
	}

	handleScrollFixed = () => {
		const spy = this.refs.spy;
		const spyRect = spy.getBoundingClientRect();
		const spySelector = spy.querySelector('.estimate-selector');
		const spySelectorRect = spySelector.getBoundingClientRect();

		if ((spyRect.top + spyRect.height) < 0) {
			if (!spy.classList.contains('-active')) {
				spy.classList.add('-active');
				spy.style.paddingBottom = `${spySelectorRect.height}px`;
			};


			const { prevScrollY } = this.state;
			const currentScrollY = window.pageYOffset;

			if (currentScrollY < prevScrollY) { spy.classList.add('-show') }
			else { spy.classList.remove('-show') }

			this.setState({ prevScrollY: currentScrollY });
		}
		else if ((spyRect.top + spyRect.height + spySelectorRect.height) > 0 && spy.classList.contains('-active')) {
			spy.classList.remove('-active');
			spy.style.paddingBottom = 0;
		}
	}
	handleSetEvacuateTopic = (keyName) => {
		const { evacuateTopics, selectedPotentialRange } = this.state;
		const dataKeys = Object.keys(evacuateTopics);
		dataKeys.forEach(key => {
			evacuateTopics[key].active = false;
		});
		evacuateTopics[keyName].active = true;
		if (keyName === 'potential' && !selectedPotentialRange) {
			return this.setState({
				isEvacuateSelected: false,
				evacuateTopics: evacuateTopics,
			})
		}
		this.setState({
			isEvacuateSelected: true,
			evacuateTopics: evacuateTopics,
		})
	}
	handleEvacuateSubmit = () => {
		console.log('handleEvacuateSubmit');
		const { selectedCounty, selectedTown, selectedVillage, evacuateTopics, selectedPotentialRange } = this.state;
		const dataKeys = Object.keys(evacuateTopics);
		const dataArray = dataKeys.map((key) => { return evacuateTopics[key] });
		const topicSlug = dataArray.find(topic => topic.active).slug;
		const countyCode = selectedCounty.code;
		const townCode = selectedTown.code;
		const villageCode = selectedVillage ? selectedVillage.code : ''
		this.setState({ isDataLoading: true });
		if (topicSlug === 'Evacuate') {
			Axios.get(`${apiHost}/api/Estimate/EvacuateEstimateBy${topicSlug}?county=${countyCode}&town=${townCode}&village=${villageCode}`)
				.then(res => {
					if (res.data.Result) {
						const { evacuateData } = this.state;
						this.handleSetContainCustom(res.data.Result['Value']);
						// evacuateData.loadFail = res.data.Result['Value'] === 0 ? true : false;
						this.setState({
							isDataLoading: false,
							evacuateData: res.data.Result,
						})
					}
					else {
						const { evacuateData } = this.state;
						evacuateData.loadFail = true;
						evacuateData['Value'] = null;
						evacuateData['Max'] = null;
						evacuateData['valueRatio'] = null;
						evacuateData['maxRatio'] = null;
						evacuateData['elderlyOccupiedHousingRatio'] = null;//僅老年人口居住宅數比率
						evacuateData['disabledPeopleRatio'] = null;//身心障礙者人口比率
						evacuateData['welfareInstitutionTotal'] = null;//社福機構數量
						evacuateData['totalEstimatedPowerLow'] = null;//預估開設所需人力(下限)
						evacuateData['totalEstimatedPowerHigh'] = null;//預估開設所需人力(上限)
						this.setState({
							isDataLoading: false,
							evacuateData: evacuateData
						});
					}
				})
		} else if (topicSlug === 'Potential') {
			Axios.get(`${apiHost}/api/Estimate/EvacuateEstimateBy${topicSlug}?county=${countyCode}&town=${townCode}&village=${villageCode}&potentialRange=${selectedPotentialRange}`)
				.then(res => {
					if (res.data.Result) {
						this.handleSetContainCustom(res.data.Result['Value']);
						this.setState({
							isDataLoading: false,
							evacuateData: res.data.Result,
						})
					}
					else {
						const { evacuateData } = this.state;
						evacuateData.loadFail = true;
						evacuateData['Value'] = null;
						evacuateData['Max'] = null;
						evacuateData['valueRatio'] = null;
						evacuateData['maxRatio'] = null;
						evacuateData['elderlyOccupiedHousingRatio'] = null;//僅老年人口居住宅數比率
						evacuateData['disabledPeopleRatio'] = null;//身心障礙者人口比率
						evacuateData['welfareInstitutionTotal'] = null;//社福機構數量
						evacuateData['totalEstimatedPowerLow'] = null;//預估開設所需人力(下限)
						evacuateData['totalEstimatedPowerHigh'] = null;//預估開設所需人力(上限)
						this.setState({
							isDataLoading: false,
							evacuateData: evacuateData
						});
					}
				})
		}
	}

	handleSetContainTopic = (keyName) => {
		const { containTopics } = this.state;
		const dataKeys = Object.keys(containTopics);
		dataKeys.forEach(key => {
			containTopics[key].active = false;
		});
		containTopics[keyName].active = true;


		this.setState({
			containTopics: containTopics,
			isContainSelected: true,
			isFirstTake: containTopics[keyName].isFirstTake
		})
	}
	handleSetContainRateFunction = (keyName) => {
		const { containRateFunction } = this.state;
		const dataKeys = Object.keys(containRateFunction);
		dataKeys.forEach(key => {
			containRateFunction[key].active = false;
		});
		containRateFunction[keyName].active = true;


		this.setState({
			containRateFunction: containRateFunction,
			isContainRateFuncSelected: true
		})
	}

	handleSetContainCustom(value) {
		const { containTopics } = this.state;
		// 限制最多7位數
		let strValue = value.toString();
		if (strValue.length > 7) {
			strValue = strValue.slice(0, 7);
		}
		let numValue = parseInt(strValue) || 0;
		if (numValue < 0) numValue = 0;
		containTopics['custom'].value = numValue;
		this.setState({
			containTopics: containTopics,
		})
	}
	handleContainSubmit = () => {
		const { selectedCounty, selectedTown, selectedVillage, containTopics, containRateFunction, selectedPotentialRange } = this.state;
		const dataKeys = Object.keys(containTopics);
		const dataArray = dataKeys.map((key) => { return containTopics[key] });
		const topicSlug = dataArray.find(topic => topic.active).slug;

		const funcKeys = Object.keys(containRateFunction);
		const funcArray = funcKeys.map((key) => { return containRateFunction[key] });
		const rateFuncSlug = funcArray.find(func => func.active) === undefined ? 'A' : funcArray.find(func => func.active).slug;//預設為A



		const countyCode = selectedCounty.code;
		const townCode = selectedTown.code;
		const villageCode = selectedVillage ? selectedVillage.code : ''
		const customNumber = containTopics['custom'].value;
		this.setState({ isDataLoading: true });

		let targetUrl = "";
		if (topicSlug === 'Contain') {//依歷史收容人口(沒有收容率估計方式)
			targetUrl = `${apiHost}/api/Estimate/ContainEstimateByContain?county=${countyCode}&town=${townCode}&village=${villageCode}`
		}
		else if (topicSlug === 'Potential') {//依潛勢人口
			if (rateFuncSlug === 'A') {//依調查數據估計
				targetUrl = `${apiHost}/api/Estimate/ContainEstimateByPotential?county=${countyCode}&town=${townCode}&village=${villageCode}&evacuate=${customNumber}&potentialRange=${selectedPotentialRange}`
			} else if (rateFuncSlug === 'B') {//依歷史收容率估計
				targetUrl = `${apiHost}/api/Estimate/ContainEstimateByPotentialHistoricalRate?county=${countyCode}&town=${townCode}&village=${villageCode}&evacuate=${customNumber}&potentialRange=${selectedPotentialRange}`
			}
		}
		else if (topicSlug === 'Custom') {//自訂撤離人口
			if (rateFuncSlug === 'A') {//依調查數據估計
				targetUrl = `${apiHost}/api/Estimate/ContainEstimateByCustom?county=${countyCode}&town=${townCode}&village=${villageCode}&evacuate=${customNumber}`
			} else if (rateFuncSlug === 'B') {//依歷史收容率估計
				targetUrl = `${apiHost}/api/Estimate/ContainEstimateByCustomHistoricalRate?county=${countyCode}&town=${townCode}&village=${villageCode}&evacuate=${customNumber}`
			}
		}

		Axios.get(targetUrl)
			.then(res => {
				if (res.data.Result) {
					const data = res.data.Result;
					let isBelowMinimumCount;

					if (containTopics['potential'].active) {
						this.handleSetSpaceCustom(data['Max'])
						isBelowMinimumCount = data['Max'] < (selectedVillage ? 20 : 70)
					} else {
						this.handleSetSpaceCustom(data['Value'])
						isBelowMinimumCount = data['Value'] < (selectedVillage ? 20 : 70)
					}

					if (containTopics['custom'].active) {
						data['maxRatio'] = null;
						data['valueRatio'] = null;
					}

					this.setState({
						isDataLoading: false,
						isBelowMinimumCount: isBelowMinimumCount,
						containData: data
					})
				}
				else {
					const { containData } = this.state;
					containData.loadFail = true;
					this.resetObjectPropertiesToNull(containData);
					this.setState({
						isDataLoading: false,
						containData: containData
					});
				}
			})
	}
	resetObjectPropertiesToNull = (obj) => {
		for (let key in obj) {
			if (obj.hasOwnProperty(key)) {
				obj[key] = null;
			}
		}
	}

	handleSetSpaceCustom = (value) => {
		// 限制最多7位數
		let strValue = value.toString();
		if (strValue.length > 7) {
			strValue = strValue.slice(0, 7);
		}
		let numValue = parseInt(strValue) || 0;
		if (numValue < 0) numValue = 0;
		this.setState({ spaceCustomNumber: numValue })
	}

	handleSetMaterialSpaceCustom = (value) => {
		// 限制最多7位數
		let strValue = value.toString();
		if (strValue.length > 7) {
			strValue = strValue.slice(0, 7);
		}
		let numValue = parseInt(strValue) || 0;
		if (numValue < 0) numValue = 0;
		this.setState({
			spaceCustomNumber: numValue,
			isMaterialDataSubmitted: false
		})
	}
	//收容空間確定按鈕
	handleSpaceSubmit = () => {
		const { selectedCounty, selectedTown, selectedVillage, spaceCustomNumber, isFirstTake } = this.state;
		const countyCode = selectedCounty.code;
		const townCode = selectedTown.code;
		const villageCode = selectedVillage ? selectedVillage.code : ''


		if (spaceCustomNumber < (selectedVillage ? 20 : 70)) {
			this.setState({ isBelowMinimumCount: true })

			if (isFirstTake) {
				return;
			}
		}
		this.setState({ isDataLoading: true });
		Axios.get(`${apiHost}/api/Estimate/ContainSpaceEstimate?county=${countyCode}&town=${townCode}&village=${villageCode}&contain=${spaceCustomNumber}`)
			.then(res => {
				if (res.data.Result) {
					this.setState({
						isDataLoading: false,
						isSpaceDataLoaded: true,
						spaceData: res.data.Result
					})
				} else {
					this.setState({ isDataLoading: false })
				}
			})

	}
	handleSetMaterialTopic = (keyName) => {
		const { materialTopics } = this.state;
		const dataKeys = Object.keys(materialTopics);
		dataKeys.forEach(key => {
			materialTopics[key].active = false;
		});
		materialTopics[keyName].active = true;

		this.setState({
			isMaterialSelected: true,
			materialTopics: materialTopics,
			isMaterialDataSubmitted: false,
		});
	}
	handleSetMaterialCustom = (value) => {
		const { materialTopics } = this.state;
		materialTopics['custom'].value = value;
		this.setState({
			materialTopics: materialTopics,
			isMaterialDataSubmitted: false,
		})
	}
	//收容物資確定按鈕
	handleMaterialSubmit = () => {
		const { materialTopics, spaceCustomNumber, selectedCounty, selectedVillage, selectedTown, isFirstTake } = this.state;
		const dataKeys = Object.keys(materialTopics);
		const dataArray = dataKeys.map((key) => { return materialTopics[key] });
		const locateSlug = dataArray.find(topic => topic.active).slug;
		const countyCode = selectedCounty.code;
		const townCode = selectedTown.code;
		const villageCode = selectedVillage ? selectedVillage.code : ''
		let customNumber = materialTopics['custom'].value;
		if (locateSlug != "-1") {
			customNumber = -1;
		}
		if (spaceCustomNumber < (selectedVillage ? 20 : 70)) {
			this.setState({ isBelowMinimumCount: true })

			if (isFirstTake) {
				return;
			}
		}


		this.setState({ isDataLoading: true });
		Axios.get(`${apiHost}/api/Estimate/ContainMaterialEstimate?county=${countyCode}&town=${townCode}&village=${villageCode}&contain=${spaceCustomNumber}&locate=${locateSlug}&custom=${customNumber}`)
			.then(res => {
				if (res.data.Result) {
					const materialData = res.data.Result.Data;
					const materialOptions = res.data.Result.Options;
					materialData.forEach(data => {
						data['Items'].forEach(item => item.active = true);
					})
					materialOptions.forEach(option => {
						option['Items'].forEach(item => { item.active = false });
						option['Items'][0].active = true;
						option['current'] = option['Items'][0]["Name"];
					});

					// 先建立一個所有 Value 為 0 的版本，讓 AnimatedNumber 先渲染
					const initialMaterialData = JSON.parse(JSON.stringify(materialData));
					initialMaterialData.forEach(data => {
						data['Items'].forEach(item => { item['Value'] = 0; });
					});

					this.setState({
						isDataLoading: false,
						isMaterialAdvance: true,
						materialData: initialMaterialData,
						materialOptions: materialOptions
					}, () => {
						this.handleSetMaterialGroup();
						// 短暫延遲後更新為實際值，觸發動畫
						setTimeout(() => {
							const { materialOptions } = this.state;
							// 根據 materialOptions 設定 active 狀態（與 handleSetMaterialGroup 相同邏輯）
							materialOptions.forEach(option => {
								const groupIndex = materialData.findIndex(data => data['Category'] === option['Category']);
								if (groupIndex) {
									option['Items'].forEach(item => {
										materialData[groupIndex]['Items'].forEach(subItem => {
											if (subItem['Name'] === item['Name']) {
												subItem.active = item.active;
											}
										})
									})
								}
							});
							this.setState({
								materialData: materialData,
								isMaterialDataSubmitted: true
							});
						}, 50);
					});
				} else {
					this.setState({ isDataLoading: false });
				}
			})



	}
	handleSetMaterialGroup = () => {
		const { materialData, materialOptions } = this.state;
		materialOptions.forEach(option => {
			const groupIndex = materialData.findIndex(data => data['Category'] === option['Category']);
			if (groupIndex) {
				option['Items'].forEach(item => {
					materialData[groupIndex]['Items'].forEach(subItem => {
						if (subItem['Name'] === item['Name']) {
							subItem.active = item.active;
						}
					})
				})
			}
		});

		this.setState({
			materialData: materialData,
			isMaterialDataSubmitted: true
		})
	}
	handleChangeMaterialGroup = (value) => {
		const { materialOptions } = this.state;
		const groupName = value.split('-')[0];
		const categoryItem = value.split('-')[1];
		materialOptions.forEach(option => {
			if (option['Group_Name'] === groupName) {
				option['Items'].forEach(item => {
					item.active = false;
					if (item['Name'] === categoryItem) {
						item.active = true;
						option['current'] = categoryItem;
					}
				})
			}
		})

		this.setState({
			materialOptions: materialOptions,
			isMaterialDataSubmitted: false
		}, () => this.handleSetMaterialGroup());
	}
	handleClickToggleInfo = (e) => {
		const controller = e.currentTarget;
		const target = e.currentTarget.dataset.target;
		const targetDom = document.querySelector(`.toggle-${target}`);
		if (controller.classList.contains('-show')) {
			controller.classList.remove('-show');
			targetDom.classList.remove('-open');
		}
		else {
			controller.classList.add('-show');
			targetDom.classList.add('-open');
		}
	}
	handleCountyDistrictPickSelected = selectedCode => {
		const { countiesTownsData } = this.state;
		const selectedDistrict = countiesTownsData.counties.find(({ code }) => code === selectedCode);
		this.setState({
			selectedCounty: selectedDistrict || null,
			selectedTown: selectedDistrict ? selectedDistrict.towns.find(t => t.code === '999') : null, // 預設為「全選」
			selectedVillage: null,
			isMaterialDataSubmitted: false
		});
	}

	handleTownDistrictPickSelected = selectedCode => {
		const { selectedCounty } = this.state
		if (selectedCounty === null || selectedCounty === undefined) return
		const selectedDistrict = selectedCounty.towns.find(({ code }) => code === selectedCode)
		this.setState({
			selectedTown: selectedDistrict,
			spaceCustomNumber: 70,
			selectedVillage: null,
			isMaterialDataSubmitted: false
		})
	}
	handleVillageDistrictPickSelected = selectedCode => {
		const { selectedTown } = this.state
		if (selectedTown === null || selectedTown === undefined) return
		const selectedDistrict = selectedTown.villages.find(({ code }) => code === selectedCode)
		this.setState({
			selectedVillage: selectedDistrict,
			spaceCustomNumber: 20,
			isMaterialDataSubmitted: false
		})
	}
	handleDownloadData = () => {
		const { selectedCounty, selectedTown, evacuateData, containData, spaceData, materialData } = this.state;
		const districtCsv = `縣市,${selectedCounty.county}\n鄉鎮,${selectedTown.town}\n`;
		const evacuateCsv = (evacuateData['Value'] ? `預估撤離人數,${evacuateData['Value']}\n` : '') +
			(evacuateData['Max'] ? `預估最大撤離人數,${evacuateData['Max']}\n` : '') +
			(evacuateData['Ratio'] ? `占戶籍人口比例,${evacuateData['Ratio']}\n` : '');
		const containCsv = (containData['Value'] ? `預估收容人數,${containData['Value']}\n` : '') +
			(containData['Max'] ? `預估最大收容人數,${containData['Max']}\n` : '') +
			(containData['Ratio'] ? `占戶籍人口比例,${containData['Ratio']}\n` : '');
		const spaceCsv = (spaceData['require'] ? `需要空間,${spaceData['require']},平方公尺\n` : '') +
			(spaceData['require'] ? `約相當於,${Math.ceil(spaceData['require'] / 72)},間國小教室\n` : '') +
			((spaceData['reality'] && spaceData['reality'] !== -1) ? `現有收容空間,${spaceData['reality']},平方公尺\n` : '') +
			((spaceData['reality'] && spaceData['reality'] === -1) ? `現有收容空間,超過五成的收容所無填報資料，無法計算。\n` : '');

		const materialCsv = materialData ? '收容物資估計\n' + materialData.map(category => {
			const items = [];
			category['Items'].forEach(item => { if (item.active) { items.push(item) } });
			const itemsCsv = items.map(item => `${item['Name']},${Math.floor(item['Value'])},${item['Unit']}\n`).join('');
			return `${category['Category']}\n${itemsCsv}\n`;
		}).join('')
			: '';

		let csv = districtCsv + '\n' +
			evacuateCsv + '\n' +
			containCsv + '\n' +
			spaceCsv + '\n' +
			materialCsv

		const fileName = `原始資料`;
		const copyright = '\n資料來源：國家災害防救科技中心減災動資料。';
		const csvContent = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv) + copyright;

		const downloadTrigger = document.createElement('a');
		downloadTrigger.setAttribute('download', fileName + '.csv');
		downloadTrigger.setAttribute('href', csvContent);
		downloadTrigger.click();
		downloadTrigger.remove();
		gaTracking('撤離與收容', '撤離與收容人數及物資估計', '數據結果下載');
	}
	handleToggleMaterialInfo = (e) => {
		const controllerDom = e.currentTarget;
		const targetDom = e.currentTarget.nextSibling;
		if (controllerDom.classList.contains('-show')) {
			controllerDom.classList.remove('-show');
			targetDom.classList.remove('-open');
		}
		else {
			controllerDom.classList.add('-show');
			targetDom.classList.add('-open');
		}
	}
	handlePotentialRangeSelected = selectedCode => {
		if (selectedCode === '0') {
			return this.setState({
				isEvacuateSelected: false,
				selectedPotentialRange: null
			});
		}
		this.setState({
			isEvacuateSelected: true,
			selectedPotentialRange: selectedCode
		});
	}

	handleResetCustomValue = () => {
		const { selectedVillage, containTopics } = this.state;
		//各推估方式的第一次，都要跳通知
		const dataKeys = Object.keys(containTopics);
		dataKeys.forEach(key => {
			if (containTopics[key].active) {
				containTopics[key].isFirstTake = false;
			}
		});

		this.setState({
			spaceCustomNumber: selectedVillage ? 20 : 70,
			isBelowMinimumCount: false,
			isFirstTake: false
		})
	}

	handleLoginRedirect = () => {
		const { history } = this.props;
		const url = history.location.pathname;
		let redirect = url ? url : '/';
		localStorage.setItem('pageBeforeLogin', redirect);
		history.push('/member/login');
	};
	//#region 收容人口
	SetEstimateContainDTO = () => {

		 // 設置下載狀態為 true
		this.setState({ isDownloading: true }, () => {

		const { EstimateContainDTO, containTopics, containRateFunction, selectedCounty, selectedTown, selectedVillage, selectedPotentialRange } = this.state;

		const dataKeys = Object.keys(containTopics);
		const dataArray = dataKeys.map((key) => { return containTopics[key] });
		const topicName = dataArray.find(topic => topic.active).name;

		const funcKeys = Object.keys(containRateFunction);
		const funcArray = funcKeys.map((key) => { return containRateFunction[key] });
		const rateFuncName = funcArray.find(func => func.active) === undefined ? '依調查數據估計' : funcArray.find(func => func.active).name;

		const customNumber = containTopics['custom'].value;
		EstimateContainDTO.County = selectedCounty ? selectedCounty.code : null;
		EstimateContainDTO.Town = selectedTown ? selectedTown.code : 999;
		EstimateContainDTO.Village = selectedVillage ? selectedVillage.code : null;
		EstimateContainDTO.FunctionType = topicName;
		EstimateContainDTO.RateFuncType = rateFuncName;
		EstimateContainDTO.PotentialRange = selectedPotentialRange;
		// 只有在選擇「自訂撤離人口」時才傳遞 Evacuate 值，否則設為 0
		EstimateContainDTO.Evacuate = containTopics['custom'].active ? customNumber : 0;

		this.setState({
			EstimateContainDTO: EstimateContainDTO
		}, () => this.DownloadFile());
	});
}

	DownloadFile() {
		Axios({
			method: 'post',
			url: `${apiHost}/api/Estimate/DownloadFile_Contain`,
			data: this.state.EstimateContainDTO,
			responseType: 'blob' // 這裡設置回應類型為 blob
		})
			.then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				const link = document.createElement('a');
				link.href = url;
				const contentDisposition = response.headers['content-disposition'];
				let fileName = '收容人口估計.xlsx';
				if (contentDisposition) {
					const fileNameMatch = contentDisposition.match(/filename\*=utf8''(.+)/);
					if (fileNameMatch) {
						if (fileNameMatch.length === 2) {
							fileName = decodeURIComponent(fileNameMatch[1]);
						}
					}
				}

			link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				// 完成後重置狀態
				this.setState({ isDownloading: false }, () => {
					// console.log('Download complete, isDownloading reset to:', this.state.isDownloading);
				});
			})
			.catch(error => {
				this.setState({ isDownloading: false }, () => {
					// console.log('Download failed, isDownloading reset to:', this.state.isDownloading);
					console.error('Download failed:', error);
				});
				// console.error('Download failed:', error);
			});

				
			// 	link.setAttribute('download', fileName);
			// 	document.body.appendChild(link);
			// 	link.click();
			// 	document.body.removeChild(link);
			// })
			// .catch(error => {
			// 	console.error('Download failed:', error);
			// });
	}
	//#endregion

	//#region 撤離人口
	// SetEstimateEvacuateDTO = () => {
	// 	const { EstimateEvacuateDTO, evacuateTopics, selectedCounty, selectedTown, selectedVillage, selectedPotentialRange } = this.state;

	// 	const dataKeys = Object.keys(evacuateTopics);
	// 	const dataArray = dataKeys.map((key) => { return evacuateTopics[key] });
	// 	const topicName = dataArray.find(topic => topic.active).name;

	// 	EstimateEvacuateDTO.County = selectedCounty ? selectedCounty.code : null;
	// 	EstimateEvacuateDTO.Town = selectedTown ? selectedTown.code : 999;
	// 	EstimateEvacuateDTO.Village = selectedVillage ? selectedVillage.code : null;
	// 	EstimateEvacuateDTO.FunctionType = topicName;
	// 	EstimateEvacuateDTO.PotentialRange = selectedPotentialRange;

	// 	this.setState({
	// 		EstimateEvacuateDTO: EstimateEvacuateDTO
	// 	}, () => this.DownloadFileEvacuate());
	// }
	// 例如 SetEstimateEvacuateDTO 方法
SetEstimateEvacuateDTO = () => {
    // 設置下載狀態為 true
		this.setState({ isDownloading: true }, () => {
        // 確認狀態已更新
        // console.log('Download started, isDownloading:', this.state.isDownloading);
        
        // 繼續原始邏輯
        const { EstimateEvacuateDTO, evacuateTopics, selectedCounty, selectedTown, selectedVillage, selectedPotentialRange } = this.state;

        const dataKeys = Object.keys(evacuateTopics);
        const dataArray = dataKeys.map((key) => { return evacuateTopics[key] });
        const topicName = dataArray.find(topic => topic.active).name;

        EstimateEvacuateDTO.County = selectedCounty ? selectedCounty.code : null;
        EstimateEvacuateDTO.Town = selectedTown ? selectedTown.code : 999;
        EstimateEvacuateDTO.Village = selectedVillage ? selectedVillage.code : null;
        EstimateEvacuateDTO.FunctionType = topicName;
        EstimateEvacuateDTO.PotentialRange = selectedPotentialRange;

        this.setState({
            EstimateEvacuateDTO: EstimateEvacuateDTO
        }, () => this.DownloadFileEvacuate());
    });
}
	DownloadFileEvacuate = () => {
		Axios({
			method: 'post',
			url: `${apiHost}/api/Estimate/DownloadFile_Evacuate`,
			data: this.state.EstimateEvacuateDTO,
			responseType: 'blob' // 這裡設置回應類型為 blob
		})
			.then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				const link = document.createElement('a');
				link.href = url;
				const contentDisposition = response.headers['content-disposition'];
				let fileName = '撤離人口估計.xlsx';
				if (contentDisposition) {
					const fileNameMatch = contentDisposition.match(/filename\*=utf8''(.+)/);
					if (fileNameMatch) {
						if (fileNameMatch.length === 2) {
							fileName = decodeURIComponent(fileNameMatch[1]);
						}
					}
				}
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				// 完成後重置狀態
				this.setState({ isDownloading: false }, () => {
					// console.log('Download complete, isDownloading reset to:', this.state.isDownloading);
				});
			})
			.catch(error => {
				this.setState({ isDownloading: false }, () => {
					// console.log('Download failed, isDownloading reset to:', this.state.isDownloading);
					console.error('Download failed:', error);
				});
				// console.error('Download failed:', error);
			});
	}
	//#endregion 撤離人口

	//#region 空間估計
	SetEstimateSpaceDTO = () => {
		  // 設置下載狀態為 true
		this.setState({ isDownloading: true }, () => {

		const { EstimateSpaceDTO, selectedCounty, selectedTown, selectedVillage, spaceCustomNumber } = this.state;
		EstimateSpaceDTO.County = selectedCounty ? selectedCounty.code : null;
		EstimateSpaceDTO.Town = selectedTown ? selectedTown.code : 999;
		EstimateSpaceDTO.Village = selectedVillage ? selectedVillage.code : null;
		EstimateSpaceDTO.Contain = spaceCustomNumber;
		this.setState({
			EstimateSpaceDTO: EstimateSpaceDTO
		}, () => this.DownloadFileSpace());
	});
}
	DownloadFileSpace = () => {
		Axios({
			method: 'post',
			url: `${apiHost}/api/Estimate/DownloadFile_Space`,
			data: this.state.EstimateSpaceDTO,
			responseType: 'blob' // 這裡設置回應類型為 blob
		})
			.then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				const link = document.createElement('a');
				link.href = url;
				const contentDisposition = response.headers['content-disposition'];
				let fileName = '收容空間估計.xlsx';
				if (contentDisposition) {
					const fileNameMatch = contentDisposition.match(/filename\*=utf8''(.+)/);
					if (fileNameMatch) {
						if (fileNameMatch.length === 2) {
							fileName = decodeURIComponent(fileNameMatch[1]);
						}
					}
				}

			link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				// 完成後重置狀態
				this.setState({ isDownloading: false }, () => {
					// console.log('Download complete, isDownloading reset to:', this.state.isDownloading);
				});
			})
			.catch(error => {
				this.setState({ isDownloading: false }, () => {
					// console.log('Download failed, isDownloading reset to:', this.state.isDownloading);
					console.error('Download failed:', error);
				});
				// console.error('Download failed:', error);
			});

			// 	link.setAttribute('download', fileName);
			// 	document.body.appendChild(link);
			// 	link.click();
			// 	document.body.removeChild(link);
			// })
			// .catch(error => {
			// 	console.error('Download failed:', error);
			// });

	}

	//#endregion

	//#region 物資估計
	SetEstimateMaterialDTO = () => {
		 // 設置下載狀態為 true
    	this.setState({ isDownloading: true }, () => {
		const { EstimateMaterialDTO, selectedCounty, selectedTown, selectedVillage, spaceCustomNumber, materialTopics, } = this.state;
		const dataKeys = Object.keys(materialTopics);
		const dataArray = dataKeys.map((key) => { return materialTopics[key] });
		const locateSlug = dataArray.find(topic => topic.active).slug;

		// 處理自訂天數
		let customNumber = materialTopics['custom'].value;
		if (locateSlug != "-1") {
			customNumber = -1;
		}

		EstimateMaterialDTO.County = selectedCounty ? selectedCounty.code : null;
		EstimateMaterialDTO.Town = selectedTown ? selectedTown.code : 999;
		EstimateMaterialDTO.Village = selectedVillage ? selectedVillage.code : null;
		EstimateMaterialDTO.Contain = spaceCustomNumber;
		EstimateMaterialDTO.Locate = locateSlug;
		EstimateMaterialDTO.Custom = customNumber;
		this.setState({
			EstimateMaterialDTO: EstimateMaterialDTO
		}, () => this.DownloadFileMaterial());

	});
}

	DownloadFileMaterial = () => {
		Axios({
			method: 'post',
			url: `${apiHost}/api/Estimate/DownloadFile_Material`,
			data: this.state.EstimateMaterialDTO,
			responseType: 'blob' // 這裡設置回應類型為 blob
		})
			.then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				const link = document.createElement('a');
				link.href = url;
				const contentDisposition = response.headers['content-disposition'];
				let fileName = '收容物資估計.xlsx';
				if (contentDisposition) {
					const fileNameMatch = contentDisposition.match(/filename\*=utf8''(.+)/);
					if (fileNameMatch) {
						if (fileNameMatch.length === 2) {
							fileName = decodeURIComponent(fileNameMatch[1]);
						}
					}
				}
			link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				// 完成後重置狀態
				this.setState({ isDownloading: false }, () => {
					// console.log('Download complete, isDownloading reset to:', this.state.isDownloading);
				});
			})
			.catch(error => {
				this.setState({ isDownloading: false }, () => {
					// console.log('Download failed, isDownloading reset to:', this.state.isDownloading);
					console.error('Download failed:', error);
				});
				// console.error('Download failed:', error);
			});
				
			// 	link.setAttribute('download', fileName);
			// 	document.body.appendChild(link);
			// 	link.click();
			// 	document.body.removeChild(link);
			// })
			// .catch(error => {
			// 	console.error('Download failed:', error);
			// });

	}
	//#endregion



	render() {

		const { evacuateTopics, evacuateData,
			containTopics, containData, containRateFunction,
			spaceData, isSpaceDataLoaded, spaceCustomNumber,
			materialTopics, materialData, materialOptions, isMaterialAdvance, isDownloading} = this.state;
		const { countiesTownsData, selectedCounty, selectedTown, selectedVillage, potentialRange, selectedPotentialRange, locationType } = this.state;
		const { isMemberLogin, isDataLoading, isEvacuateSelected, isContainSelected, isContainRateFuncSelected, isMaterialSelected, isMaterialDataSubmitted, isBelowMinimumCount, isFirstTake } = this.state;
		const allMaterialSource = [];
		materialData && materialData.map(data => data["Items"].map(item => {
			const div = document.createElement('div');
			div.innerHTML = item["Source"];
			const dom = div.firstChild || null;
			const content = dom && dom.textContent;
			if (item["Source"] && allMaterialSource.indexOf(content) === -1) {
				allMaterialSource.push(content);
			}
		}));
		return (
			<React.Fragment>
				<Helmet>
					<title>減災動資料 - 撤離與收容評估</title>
				</Helmet>
				<LimitMask prevPage="/evaluation/evacuation" />
				<div className="evacuation-page">
					<div className="container">
						<div className="page-link">
							<Link className="item" to="/evaluation/evacuation/evacuate">
								<span>歷史撤離人次查詢</span>
							</Link>
							<Link className="item" to="/evaluation/evacuation/contain">
								<span>歷史收容人次查詢</span>
							</Link>
							<Link className="item" to="/evaluation/evacuation/alert">
								<span>歷史警戒熱區查詢</span>
							</Link>
							<Link className="item" to="/evaluation/evacuation/shelter">
								<span>收容所資訊查詢</span>
							</Link>
						</div>
						<div ref="spy" className="estimate-heading">
							<div className="evacuation-chart-title">
								<div className="title">撤離與收容人數及物資估計</div>
							</div>
							<div className="estimate-description">
								面對來勢洶洶的颱風豪雨，要先撤離多少人才能確保居民平安渡過災害？撤離之後，要準備多少收容空間和物資呢？<br />
								本系統提供撤離收容人口、空間、物資估算的功能，您可以依序輸入您所在的位置，並選擇推估方式，來估算撤離或收容的人口，並根據這些數據，進一步估算收容所需要的空間與物資儲備。<br />
								若您已經了解要撤離或收容的人數，也可以點選下方按鈕，直接跳轉到空間與物資估計的單元進行估算。
							</div>
							<div className="estimate-selector">
								<div className="buttonbar">
									<button onClick={() => Scroll.scroller.scrollTo('evacuate', { smooth: true })}>撤離人口估計</button>
									<button onClick={() => Scroll.scroller.scrollTo('contain', { smooth: true })}>收容人口估計</button>
									<button onClick={() => Scroll.scroller.scrollTo('space', { smooth: true })}>收容空間估計</button>
									<button onClick={() => Scroll.scroller.scrollTo('material', { smooth: true })}>收容物資估計</button>
								</div>
							</div>
						</div>


						<Scroll.Element name="evacuate">
							<section className="estimate-section">

								{/* 因更改為不需登入也能使用此功能，因此先註解登入狀態的判斷 */}
								{/* {
									!isMemberLogin &&
									<LoginMask>
										<p>請先登入會員再進行操作</p>
										<button className="fill-button -pink" onClick={this.handleLoginRedirect}>登入</button>
									</LoginMask>
								} */}

								<div className="controller-bar">
									<div className="heading">撤離人口估計</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 1</span>
												<span>選擇您所在的位置</span>
											</div>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="county"
												value={selectedCounty ? selectedCounty.code : ''}
												onChange={value => this.handleCountyDistrictPickSelected(value)}>
												<option value="0">選縣市（單選）</option>
												{
													countiesTownsData &&
													countiesTownsData.counties.map((item, index) =>
														<option key={index} value={item.code}>{item.county}</option>
													)
												}
											</CustomSelect>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="town"
												value={selectedTown ? selectedTown.code : ''}
												onChange={value => this.handleTownDistrictPickSelected(value)}>
												<option value="0">選鄉鎮（單選）</option>
												{
													countiesTownsData &&
													countiesTownsData.counties.map(item =>
														item === selectedCounty && item.towns.map((subItem, index) =>
															<option key={index} value={subItem.code}>{subItem.town}</option>
														)
													)
												}
											</CustomSelect>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="village"
												value={selectedVillage ? selectedVillage.code : ''}
												onChange={value => this.handleVillageDistrictPickSelected(value)}>
												<option value="0">選村里（單選）</option>
												{
													selectedTown &&
													<option value="">全選</option>
												}
												{
													countiesTownsData &&
													countiesTownsData.counties.map(item =>
														item === selectedCounty && item.towns.map((subItem, index) =>
															subItem === selectedTown && subItem.villages.map((village, index) =>
																<option key={index} value={village.code}>{village.village}</option>
															)
														)
													)
												}
											</CustomSelect>
										</div>
									</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 2</span>
												<span>選擇推估方式</span>
											</div>
											<button className="toggle-btn" data-target="evacuate" onClick={this.handleClickToggleInfo}>
												<span className="open">說明</span>
												<span className="close">關閉</span>
												<i className="icon-info"></i>
											</button>
										</div>
										<div className="buttonbar">
											<button className={`${evacuateTopics['evacuate'].active ? '-active' : ''}`}
												onClick={() => this.handleSetEvacuateTopic('evacuate')} disabled={selectedVillage}
											>{evacuateTopics['evacuate'].name}</button>
											<button className={`${evacuateTopics['potential'].active ? '-active' : ''}`}
												onClick={() => this.handleSetEvacuateTopic('potential')}
											>{evacuateTopics['potential'].name}</button>
										</div>
										{
											evacuateTopics.potential.active &&
											<div className="select">
												<CustomSelect status="normal"
													value={selectedPotentialRange ? selectedPotentialRange : ''}
													onChange={value => this.handlePotentialRangeSelected(value)}>
													<option value="0">選潛勢規模（單選）</option>
													{
														potentialRange &&
														potentialRange.map((item, index) =>
															<option key={index} value={item}>{item + 'mm/日'}</option>
														)
													}
												</CustomSelect>
											</div>
										}
									</div>
									<div className="description -toggle toggle-evacuate">
										＊依歷史撤離人口：依據該鄉鎮市區過去颱風豪雨事件之平均撤離人次及最大撤離人次所進行的估計。目前尚無村里統計。<br />
										＊依潛勢人口：依據政府列冊之土石流及大規模崩塌保全人口與淹水保全或潛勢範圍推估而得。預估撤離人數為最小值，預估最大撤離人數則為最大值。<br />
										＊各地區推估結果因取得資料完整性不同，部分地區可能無撤離人口，建議仍應做好相關整備工作。<br />
									</div>

									{isDataLoading && <LoadingDots theme="red" />}

									<div className="submit">
										<button
											onClick={this.handleEvacuateSubmit}
											disabled={!selectedCounty || !selectedTown || !isEvacuateSelected}
										>確定</button>
										{/* <button className="button-pink" disabled={!selectedCounty || !selectedTown || !isEvacuateSelected} onClick={this.SetEstimateEvacuateDTO}>下載數據結果</button> */}
										{/* // 在按鈕處添加條件渲染 */}
										<button 
											className="button-pink" 
											disabled={!selectedCounty || !selectedTown || !isEvacuateSelected || isDownloading} 
											onClick={this.SetEstimateEvacuateDTO}
										>
											{isDownloading && 
												<img src={spinnerGif}  className="button-spinner" />
											}
											下載數據結果
										</button>
									</div>
								</div>
								<div className="result-content">
									{isDataLoading && <LoadingDots theme="red" />}
									<div className="heading">撤離人口估算結果</div>
									<div className="result">
										<div className="estimate-number">
											<div className="label">預估撤離人數：</div>
											<div className="content">
												{
													evacuateData['Value'] === -1 ? "-" :
														<>
															<AnimatedNumber
																className={this.getValueClassName(evacuateData['Value'])}
																duration={300}
																formatValue={n => transferHundredPoint(Math.floor(n))}
																value={evacuateData['Value']}
															/>
															<span className="unit">人</span>
														</>
												}
											</div>
										</div>
										<div className="estimate-number">
											<div className="label">預估最大撤離人數：</div>
											<div className="content">
												{
													evacuateData['Max'] === -1 ? "-" :
														<>
															<AnimatedNumber
																className={this.getValueClassName(evacuateData['Max'])}
																duration={300}
																formatValue={n => transferHundredPoint(Math.floor(n))}
																value={evacuateData['Max']}
															/>
															<span className="unit">人</span>
														</>
												}
											</div>
										</div>

										<div className="estimate-RP-box">
											<div className="lable-RP lable-RP-small">占戶籍人口比率:</div>
											<div className="content-RP">
												{
													evacuateData['valueRatio'] == null || evacuateData['maxRatio'] == null || evacuateData['valueRatio'] === -1 || evacuateData['maxRatio'] === -1 ?
														<span className='num-small'>-</span> :
														<>
															<span className='num-small'>{evacuateData['valueRatio']} ~ {evacuateData['maxRatio']}</span>
															<span>%</span>
														</>
												}
											</div>
										</div>


										

										
										<div className="estimate-RP-box">
										<div></div>
										{
												evacuateData['Value'] === -1 && <div>
													<p className="estimate-RP-noinfo">該區域無歷史資料,無法計算。</p>
												</div>
											}
										</div>

										

											
										<div className="estimate-RP-otherinfo-wrap">
											<div>
												<p>轄內其他參考資訊</p>
												<dl className="estimate-RP-otherinfo-dl">
													<dt>僅老年人口居住宅數比率:</dt>
													<dd>
														{
															(evacuateData['elderlyOccupiedHousingRatio'] == null || evacuateData['elderlyOccupiedHousingRatio'] === -1) ?
																<span>-</span> :
																<>
																	<span>{evacuateData['elderlyOccupiedHousingRatio']}</span>
																	<span>%</span>
																</>
														}
													</dd>
												</dl>
												<dl className="estimate-RP-otherinfo-dl">
													<dt>身心障礙人口比率:</dt>
													<dd>
														{
															(evacuateData['disabledPeopleRatio'] == null || evacuateData['disabledPeopleRatio'] === -1) ?
																<span>-</span> :
																<>
																	<span>{evacuateData['disabledPeopleRatio']}</span>
																	<span>%</span>
																</>
														}
													</dd>
												</dl>
												<dl className="estimate-RP-otherinfo-dl">
													<dt>社福機構數量:</dt>
													<dd>
														{
															(evacuateData['welfareInstitutionTotal'] == null || evacuateData['welfareInstitutionTotal'] === -1) ?
																<span>-</span> :
																<>
																	<span>{transferHundredPoint(evacuateData['welfareInstitutionTotal'])}</span>
																	<span>間</span>
																</>
														}
													</dd>
												</dl>

												
											</div>
											
											
										</div>


									</div>


								</div>
							</section>
						</Scroll.Element>


						<Scroll.Element name="contain">
							<section className="estimate-section">


								{/* 因更改為不需登入也能使用此功能，因此先註解登入狀態的判斷 */}
								{/* {
									!isMemberLogin &&
									<LoginMask>
										<p>請先登入會員再進行操作</p>
										<button className="fill-button -pink" onClick={this.handleLoginRedirect}>登入</button>
									</LoginMask>
								} */}

								<div className="controller-bar">
									<div className="heading">收容人口估計</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 1</span>
												<span>選擇您所在的位置</span>
											</div>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="county"
												value={selectedCounty ? selectedCounty.code : ''}
												onChange={value => this.handleCountyDistrictPickSelected(value)}>
												<option value="0">選縣市（單選）</option>
												{
													countiesTownsData &&
													countiesTownsData.counties.map((item, index) =>
														<option key={index} value={item.code}>{item.county}</option>
													)
												}
											</CustomSelect>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="town"
												value={selectedTown ? selectedTown.code : ''}
												onChange={value => this.handleTownDistrictPickSelected(value)}>
												<option value="0">選鄉鎮（單選）</option>
												{
													countiesTownsData &&
													countiesTownsData.counties.map(item =>
														item === selectedCounty && item.towns.map((subItem, index) =>
															<option key={index} value={subItem.code}>{subItem.town}</option>
														)
													)
												}
											</CustomSelect>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="village"
												value={selectedVillage ? selectedVillage.code : ''}
												onChange={value => this.handleVillageDistrictPickSelected(value)}>
												<option value="0">選村里（單選）</option>
												{
													selectedTown &&
													<option value="">全選</option>
												}
												{
													countiesTownsData &&
													countiesTownsData.counties.map(item =>
														item === selectedCounty && item.towns.map((subItem, index) =>
															subItem === selectedTown && subItem.villages.map((village, index) =>
																<option key={index} value={village.code}>{village.village}</option>
															)
														)
													)
												}
											</CustomSelect>
										</div>
									</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 2</span>
												<span>選擇推估方式</span>
											</div>
											<button className="toggle-btn" data-target="contain" onClick={this.handleClickToggleInfo}>
												<span className="open">說明</span>
												<span className="close">關閉</span>
												<i className="icon-info"></i>
											</button>
										</div>
										<div className="buttonbar">
											<button className={`${containTopics['evacuate'].active ? '-active' : ''}`}
												onClick={() => this.handleSetContainTopic('evacuate')} disabled={selectedVillage}
											>{containTopics['evacuate'].name}</button>
											<button className={`${containTopics['potential'].active ? '-active' : ''}`}
												onClick={() => this.handleSetContainTopic('potential')}
											>{containTopics['potential'].name}</button>
											{
												containTopics.potential.active &&
												<div className="select">
													<CustomSelect status="normal"
														value={selectedPotentialRange ? selectedPotentialRange : ''}
														onChange={value => this.handlePotentialRangeSelected(value)}>
														<option value="0">選潛勢規模（單選）</option>
														{
															potentialRange &&
															potentialRange.map((item, index) =>
																<option key={index} value={item}>{item + 'mm/日'}</option>
															)
														}
													</CustomSelect>
												</div>
											}
											<button className={`${containTopics['custom'].active ? '-active' : ''}`}
												onClick={() => this.handleSetContainTopic('custom')}
											>{containTopics['custom'].name}</button>
										</div>
										{
											containTopics['custom'].active &&
											<div className="input">
												<span>自訂撤離</span>
												<input type="number"
													value={containTopics['custom'].value === -1 ? 0 : containTopics['custom'].value}
													onFocus={() => this.handleSetContainTopic('custom')}
													onChange={(e) => this.handleSetContainCustom(e.currentTarget.value)}
													min="0"
													max="9999999"
												/>
												<span>人</span>
											</div>
										}
									</div>
									{
										!containTopics['evacuate'].active &&
										<div className="controller">
											<div className='title'>
												<div className="step">
													<span>Step 3</span>
													<span>收容率估計方式</span>
												</div>
													<button className="toggle-btn" data-target="contain_method" onClick={this.handleClickToggleInfo}>
														<span className="open">說明</span>
														<span className="close">關閉</span>
														<i className="icon-info"></i>
													</button>
											</div>
											<div className="buttonbar">
												<button className={`${containRateFunction['A'].active ? '-active' : ''}`}
													onClick={() => this.handleSetContainRateFunction('A')}
												>{containRateFunction['A'].name}</button>

												<button className={`${containRateFunction['B'].active ? '-active' : ''}`}
													onClick={() => this.handleSetContainRateFunction('B')}
												>{containRateFunction['B'].name}</button>

											</div>
										</div>
									}

									<div className="description -toggle toggle-contain">
										＊依歷史收容人口：依據該鄉鎮市區歷年颱風豪雨事件平均收容人次及最大收容人次所進行的估計。目前尚無村里統計。<br />
										＊依潛勢人口：依據政府列冊之保全人口與潛勢範圍設定撤離人數後(含淹水與「土石流及大規模崩塌」災害)，使用者可利用step3，選擇「依調查數據估計」或「依歷史收容率估計」來推估收容人口。<br />
										＊自訂撤離人口：使用者自訂撤離人口後，選擇依調查數據估計時，採以全台平均收容率作估計。選擇依歷史收容率估計時，採縣市颱洪事件收容率最大值做估計。<br />
										＊各地區推估結果因取得資料完整性不同，部分地區可能無收容人口，建議仍應做好相關整備工作。<br />
									</div>

									<div className="description -toggle toggle-contain_method">									
										＊依調查數據估計：依據NCDR針對全臺進行之「2018水災及坡災收容意向調查」數據做估計，欲知詳情，見主題館文章或NCDR 107-T01技術報告。<br />
										＊依歷史收容率估計：依據EMIC記載該地區所有颱洪事件中，收容人口占撤離人口的比率估計而得，系統取其中最大值為參數做估計。<br />										
									</div>

									<div className="submit">
										<button
											disabled={!selectedCounty || !selectedTown || !isContainSelected || (!containTopics['evacuate'].active && !isContainRateFuncSelected) || (containTopics['potential'].active && !selectedPotentialRange)}
											onClick={this.handleContainSubmit}>確定</button>
										{/* <button className="button-pink" disabled={!selectedCounty || !selectedTown || !isContainSelected || (!containTopics['evacuate'].active && !isContainRateFuncSelected) || (containTopics['potential'].active && !selectedPotentialRange)}
											onClick={this.SetEstimateContainDTO}>下載數據結果</button> */}
											<button 
											className="button-pink" 
											disabled={!selectedCounty || !selectedTown || !isContainSelected || (!containTopics['evacuate'].active && !isContainRateFuncSelected) || (containTopics['potential'].active && !selectedPotentialRange) || isDownloading} 
											onClick={this.SetEstimateContainDTO}
										>
											{isDownloading && 
												<img src={spinnerGif}  className="button-spinner" />
											}
											下載數據結果
										</button>
									</div>
								</div>
								<div className="result-content">
									{isDataLoading && <LoadingDots theme="red" />}
									<div className="heading">收容人口估算結果</div>
									<div className="result">
										<div className="estimate-number">
											<div className="label">預估收容人數：</div>
											<div className="content">
												{
													containData['Value'] === -1 ? "-" : (
														<>
															<AnimatedNumber
																className={this.getValueClassName(containData['Value'])}
																duration={300}
																formatValue={n => transferHundredPoint(Math.floor(n))}
																value={containData['Value']}
															/>
															<span className="unit">人</span>
														</>
													)
												}
											</div>
										</div>







										<div className="estimate-RP-box estimate-RP-box-start">
											<div className="lable-RP">預估開設所需人力:</div>
											<div className="content-RP-column">
												{/* <div>
												{
														(!containData.hasOwnProperty('totalEstimatedPowerLow') && !containData.hasOwnProperty('totalEstimatedPowerHigh')&&
															(containData['totalEstimatedPowerLow'] == null || containData['totalEstimatedPowerHigh'] == null || containData['totalEstimatedPowerLow'] === -1 || containData['totalEstimatedPowerHigh'] === -1 )) ?
															<span className='num'>-</span> :
															(!containData.hasOwnProperty('totalEstimatedPowerLow') && !containData.hasOwnProperty('totalEstimatedPowerHigh')&&
																<>
																	<span className='num'>{transferHundredPoint(containData['totalEstimatedPowerLow'])} ~ {transferHundredPoint(containData['totalEstimatedPowerHigh'])}</span>
																	<span>人</span>
																</>)
													}
												</div> */}
												<div>
													{
														(containData.hasOwnProperty('totalEstimatedPowerLow') && containData.hasOwnProperty('totalEstimatedPowerHigh')&&
															(containData['totalEstimatedPowerLow'] == null || containData['totalEstimatedPowerHigh'] == null || containData['totalEstimatedPowerLow'] === -1 || containData['totalEstimatedPowerHigh'] === -1 )) ?
															<span className='num'>-</span> :
															(containData.hasOwnProperty('totalEstimatedPowerLow') && containData.hasOwnProperty('totalEstimatedPowerHigh')&&
																<>
																	<span className='num'>{transferHundredPoint(containData['totalEstimatedPowerLow'])} ~ {transferHundredPoint(containData['totalEstimatedPowerHigh'])}</span>
																	<span>人</span>
																</>)
													}
												</div>
												<div>
													<button className="toggle-btn" data-target="estimatedPower" onClick={this.handleClickToggleInfo}>
														<span className="open">說明</span>
														<span className="close">關閉</span>
														<i className="icon-info"></i>
													</button>
													<div className="description -toggle toggle-estimatedPower" style={{ fontSize: '14px', lineHeight: '22px', color: '#000', textAlign: 'left' }}>
														＊人力預估基準：收容人數100人以下時，需求人力預估為4-6人。每超過100人時，再增加2-4人。
														<br/>＊注意：預估之人力預設為一班之人力需求，若有輪班時，需以此為基準再進行預估。
													</div>
												</div>
											</div>
										</div>







										{
											!containTopics['custom'].active &&
											<div className="estimate-number">
												<div className="label">預估最大收容人數：</div>
												<div className="content">
													{
														containData['Max'] === -1 ? "-" :
															<>
																<AnimatedNumber
																	className={this.getValueClassName(containData['Max'])}
																	duration={300}
																	formatValue={n => transferHundredPoint(Math.floor(n))}
																	value={containData['Max']}
																/>
																<span className="unit">人</span>
															</>
													}
												</div>
											</div>
											}		

											{
												!containTopics['custom'].active &&

										<div className="estimate-RP-box estimate-RP-box-start">
											<div className="lable-RP">預估開設所需最大人力:</div>
											<div className="content-RP-column">
												{/* <div>
												{
														(!containData.hasOwnProperty('totalEstimatedMaxPowerLow') && !containData.hasOwnProperty('totalEstimatedMaxPowerHigh')&&
															(containData['totalEstimatedMaxPowerLow'] == null || containData['totalEstimatedMaxPowerHigh'] == null || containData['totalEstimatedMaxPowerLow'] === -1 || containData['totalEstimatedMaxPowerHigh'] === -1 )) ?
															<span className='num'>-</span> :
															(!containData.hasOwnProperty('totalEstimatedMaxPowerLow') && !containData.hasOwnProperty('totalEstimatedMaxPowerHigh')&&
																<>
																	<span className='num'>{containData['totalEstimatedMaxPowerLow']} ~ {containData['totalEstimatedMaxPowerHigh']}</span>
																	<span>人</span>
																</>)
													}
												</div> */}
												<div>
													{
														(containData.hasOwnProperty('totalEstimatedMaxPowerLow') && containData.hasOwnProperty('totalEstimatedMaxPowerHigh')&&
															(containData['totalEstimatedMaxPowerLow'] == null || containData['totalEstimatedMaxPowerHigh'] == null || containData['totalEstimatedMaxPowerLow'] === -1 || containData['totalEstimatedMaxPowerHigh'] === -1 )) ?
															<span className='num'>-</span> :
															(containData.hasOwnProperty('totalEstimatedMaxPowerLow') && containData.hasOwnProperty('totalEstimatedMaxPowerHigh')&&
																<>
																	<span className='num'>{transferHundredPoint(containData['totalEstimatedMaxPowerLow'])} ~ {transferHundredPoint(containData['totalEstimatedMaxPowerHigh'])}</span>
																	<span>人</span>
																</>)
													}
												</div>
												{/* <div> */}
													{/* <button className="toggle-btn" data-target="estimatedPower" onClick={this.handleClickToggleInfo}>
														<span className="open">說明</span>
														<span className="close">關閉</span>
														<i className="icon-info"></i>
													</button> */}
													<div className="description -toggle toggle-estimatedPower" style={{ fontSize: '14px', lineHeight: '22px', color: '#000', textAlign: 'left' }}>
														＊人力預估基準：收容人數100人以下時，需求人力預估為4-6人。每超過100人時，再增加2-4人。
														<br/>＊注意：預估之人力預設為一班之人力需求，若有輪班時，需以此為基準再進行預估。
													</div>
												{/* </div> */}
											</div>
										</div>
									}

										<div className="estimate-RP-box">
											<div className="lable-RP lable-RP-small">占戶籍人口比率:</div>
											<div className="content-RP">
												{
													(!containData.hasOwnProperty('Ratio') &&
														(containData['valueRatio'] == null || containData['maxRatio'] == null || containData['valueRatio'] === -1 || containData['maxRatio'] === -1)) ?
														<span className='num-small'>-</span> :
														(!containData.hasOwnProperty('Ratio') &&
															<>
																<span className='num-small'>{containData['valueRatio']} ~ {containData['maxRatio']}</span>
																<span>%</span>
															</>)
												}

												{
													(containData.hasOwnProperty('Ratio') &&
														(containData['Ratio'] == null || containData['Ratio'] == -1)) ?
														<span className='num-small'>-</span> :
														(containData.hasOwnProperty('Ratio') &&
															<>
																<span className='num-small'>{containData['Ratio']}</span>
																<span>%</span>
															</>)
												}
											</div>
										</div>





										<div className="estimate-RP-box">
										<div></div>
										{
												containData['Value'] === -1 && <div>
													<p className="estimate-RP-noinfo">該區域無歷史資料,無法計算。</p>
												</div>
											}				
										</div>



									



										<div className="estimate-RP-otherinfo-wrap">
											<div>
												<p>轄內其他參考資訊</p>
												<dl className="estimate-RP-otherinfo-dl">
													<dt>僅老年人口居住宅數比率:</dt>
													<dd>
														{
															(containData['elderlyOccupiedHousingRatio'] == null || containData['elderlyOccupiedHousingRatio'] === -1) ?
																<span>-</span> :
																<>
																	<span>{containData['elderlyOccupiedHousingRatio']}</span>
																	<span>%</span>
																</>
														}
													</dd>
												</dl>
												<dl className="estimate-RP-otherinfo-dl">
													<dt>身心障礙人口比率:</dt>
													<dd>
														{
															(containData['disabledPeopleRatio'] == null || containData['disabledPeopleRatio'] === -1) ?
																<span>-</span> :
																<>
																	<span>{containData['disabledPeopleRatio']}</span>
																	<span>%</span>
																</>
														}
													</dd>
												</dl>
												<dl className="estimate-RP-otherinfo-dl">
													<dt>社福機構數量:</dt>
													<dd>
														{
															(containData['welfareInstitutionTotal'] == null || containData['welfareInstitutionTotal'] === -1) ?
																<span>-</span> :
																<>
																	<span>{transferHundredPoint(containData['welfareInstitutionTotal'])}</span>
																	<span>間</span>
																</>
														}
													</dd>
												</dl>
											</div>
											

										</div>
									</div>
								</div>
							</section>
						</Scroll.Element>


						<Scroll.Element name="space">
							<section className="estimate-section">

								{/* 因更改為不需登入也能使用此功能，因此先註解登入狀態的判斷 */}
								{/* {
									!isMemberLogin &&
									<LoginMask>
										<p>請先登入會員再進行操作</p>
										<button className="fill-button -pink" onClick={this.handleLoginRedirect}>登入</button>
									</LoginMask>
								} */}
								{
									(isBelowMinimumCount && isFirstTake) &&
									<CustomMsgMask>
										<p className='title'>系統提醒</p>
										<p className='content'>系統預設最低收容人數在「鄉鎮」時為70人，在「村里」時為20人。</p>
										<button className="fill-button -pink" onClick={this.handleResetCustomValue} >確認</button>
									</CustomMsgMask>
								}
								<div className="controller-bar">
									<div className="heading">收容空間估計</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 1</span>
												<span>輸入預估收容人數</span>
											</div>
										</div>
										<div className="input">
											<span>預計收容</span>
											<input type="number"
												value={spaceCustomNumber}
												onChange={(e) => this.handleSetSpaceCustom(e.currentTarget.value)}
												onBlur={(e) => this.handleSetSpaceCustom(e.currentTarget.value)}
												min="0"
												max="9999999"
											/>
											<span>人</span>
										</div>
									</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 2</span>
												<span>請選擇您所在的位置</span>
											</div>
											<button className="toggle-btn" data-target="space" onClick={this.handleClickToggleInfo}>
												<span className="open">說明</span>
												<span className="close">關閉</span>
												<i className="icon-info"></i>
											</button>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="county"
												value={selectedCounty ? selectedCounty.code : ''}
												onChange={value => this.handleCountyDistrictPickSelected(value)}>
												<option value="0">選縣市（單選）</option>
												{
													countiesTownsData &&
													countiesTownsData.counties.map((item, index) =>
														<option key={index} value={item.code}>{item.county}</option>
													)
												}
											</CustomSelect>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="town"
												value={selectedTown ? selectedTown.code : ''}
												onChange={value => this.handleTownDistrictPickSelected(value)}>
												<option value="0">選鄉鎮（單選）</option>
												{
													countiesTownsData &&
													countiesTownsData.counties.map(item =>
														item === selectedCounty && item.towns.map((subItem, index) =>
															<option key={index} value={subItem.code}>{subItem.town}</option>
														)
													)
												}
											</CustomSelect>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="village"
												value={selectedVillage ? selectedVillage.code : ''}
												onChange={value => this.handleVillageDistrictPickSelected(value)}>
												<option value="0">選村里（單選）</option>
												{
													selectedTown &&
													<option value="">全選</option>
												}
												{
													countiesTownsData &&
													countiesTownsData.counties.map(item =>
														item === selectedCounty && item.towns.map((subItem, index) =>
															subItem === selectedTown && subItem.villages.map((village, index) =>
																<option key={index} value={village.code}>{village.village}</option>
															)
														)
													)
												}
											</CustomSelect>
										</div>
									</div>
									<div className="description -toggle toggle-space">
										＊收容空間估計標準：每人 4 平方公尺（預設為個人使用空間）。<br />
										＊個人使用空間參考依據：<br />
										- Alameda County Operational Area Emergency Management Organization (2003) A Guide for Local Jurisdictions In Care and Shelter Planning, P.57. <br />
										- American red cross (2012) Sheltering Handbook Disaster Services, P2-10.<br />
										＊國小教室計算標準：72 平方公尺/間（參考來源：國民小學及國民中學設施設備基準2019年修訂版）。<br />
										＊現有收容空間之統計依各縣市公告及系統回報(見首頁說明)，無法判別是否已扣除公共使用空間，使用時請留意。<br />
										＊本系統收容空間估計依據收容人數而定，系統預設最低收容人數在「鄉鎮」時為70人，在「村里」時為20人，使用者另也可自訂。<br />
									</div>
									<div className="submit">
										<button
											disabled={!selectedCounty || !selectedTown}
											onClick={this.handleSpaceSubmit}>確定</button>
										{/* <button className="button-pink" disabled={!selectedCounty || !selectedTown} onClick={this.SetEstimateSpaceDTO}>下載數據結果</button> */}
										<button 
											className="button-pink" 
											disabled={!selectedCounty || !selectedTown || isDownloading} 
											onClick={this.SetEstimateSpaceDTO}
										>
											{isDownloading && 
												<img src={spinnerGif}  className="button-spinner" />
											}
											下載數據結果
										</button>
									</div>
								</div>
								<div className="result-content">
									{isDataLoading && <LoadingDots theme="red" />}
									<div className="heading">收容空間估算結果</div>
									<div className="result">
										<div className="estimate-number">
											<div className="label">需要空間：</div>
											<div className="content">
												{
													spaceData.require === -1 ? <span className="type-text -en value">-</span> :
														<>
															<AnimatedNumber
																className={this.getValueClassName(spaceData.require)}
																duration={300}
																formatValue={n => transferHundredPoint(Math.floor(n))}
																value={spaceData.require}
															/>
															<span className="unit">平方公尺</span>
														</>
												}
											</div>
										</div>
										<div className="estimate-number">
											<div className="label">約相當於：</div>
											<div className="content">
												<AnimatedNumber
													className={this.getValueClassName(Math.ceil(spaceData.require / 72))}
													duration={300}
													formatValue={n => transferHundredPoint(Math.floor(n))}
													value={Math.ceil(spaceData.require / 72)}
												/>
												<span className="unit">間國小教室</span>
											</div>
										</div>
										<div className="estimate-number">
											<div className="label">現有收容空間：</div>
											{
												spaceData.reality !== -1 &&
												<div className="content">
													<AnimatedNumber
														className={this.getValueClassName(Math.ceil(spaceData.reality))}
														duration={300}
														formatValue={n => transferHundredPoint(Math.floor(n))}
														value={Math.ceil(spaceData.reality)}
													/>
													<span className="unit">平方公尺</span>
													{(isSpaceDataLoaded && spaceData.reality >= spaceData.require) && <span className="face"><img src={spaceSuccessSvg} alt="" /></span>}
													{(isSpaceDataLoaded && spaceData.reality < spaceData.require) && <span className="face"><img src={spaceAlertSvg} alt="" /></span>}
												</div>
											}
											{
												spaceData.reality === -1 &&
												<div className="content">
													<span className="unit">超過五成的收容所無填報資料，無法計算。</span>
												</div>
											}
										</div>
									</div>
								</div>
							</section>
						</Scroll.Element>


						<Scroll.Element name="material">
							<section className="estimate-section">

								{/* 因更改為不需登入也能使用此功能，因此先註解登入狀態的判斷 */}
								{/* {
									!isMemberLogin &&
									<LoginMask>
										<p>請先登入會員再進行操作</p>
										<button className="fill-button -pink" onClick={this.handleLoginRedirect}>登入</button>
									</LoginMask>
								} */}
								{
									(isBelowMinimumCount && isFirstTake) &&
									<CustomMsgMask>
										<p className='title'>系統提醒</p>
										<p className='content'>系統預設最低收容人數在「鄉鎮」時為70人，在「村里」時為20人。</p>
										<button className="fill-button -pink" onClick={this.handleResetCustomValue} >確認</button>
									</CustomMsgMask>
								}
								<div className="controller-bar">
									<div className="heading">收容物資估計</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 1</span>
												<span>請選擇您所在的位置</span>
											</div>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="county"
												value={selectedCounty ? selectedCounty.code : ''}
												onChange={value => this.handleCountyDistrictPickSelected(value)}>
												<option value="0">選縣市（單選）</option>
												{
													countiesTownsData &&
													countiesTownsData.counties.map((item, index) =>
														<option key={index} value={item.code}>{item.county}</option>
													)
												}
											</CustomSelect>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="town"
												value={selectedTown ? selectedTown.code : ''}
												onChange={value => this.handleTownDistrictPickSelected(value)}>
												<option value="0">選鄉鎮（單選）</option>
												{
													countiesTownsData &&
													countiesTownsData.counties.map(item =>
														item === selectedCounty && item.towns.map((subItem, index) =>
															<option key={index} value={subItem.code}>{subItem.town}</option>
														)
													)
												}
											</CustomSelect>
										</div>
										<div className="select">
											<CustomSelect status="normal" name="village"
												value={selectedVillage ? selectedVillage.code : ''}
												onChange={value => this.handleVillageDistrictPickSelected(value)}>
												<option value="0">選村里（單選）</option>
												{
													selectedTown &&
													<option value="">全選</option>
												}
												{
													countiesTownsData &&
													countiesTownsData.counties.map(item =>
														item === selectedCounty && item.towns.map((subItem, index) =>
															subItem === selectedTown && subItem.villages.map((village, index) =>
																<option key={index} value={village.code}>{village.village}</option>
															)
														)
													)
												}
											</CustomSelect>
										</div>
									</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 2</span>
												<span>輸入預估收容人數</span>
											</div>
											<button className="toggle-btn" data-target="material" onClick={this.handleClickToggleInfo}>
												<span className="open">說明</span>
												<span className="close">關閉</span>
												<i className="icon-info"></i>
											</button>
										</div>
										<div className="input">
											<span>預計收容</span>
											<input type="number"
												value={spaceCustomNumber}
												onChange={(e) => this.handleSetMaterialSpaceCustom(e.currentTarget.value)}
												onBlur={(e) => this.handleSetMaterialSpaceCustom(e.currentTarget.value)}
												min="0"
												max="9999999"
											/>
											<span>人</span>
										</div>
									</div>
									<div className="controller">
										<div className="title">
											<div className="step">
												<span>Step 3</span>
												<span>選擇您要儲備的天數</span>
											</div>
										</div>
										<div className="buttonbar">
											<button className={`${materialTopics['mountain'].active ? '-active' : ''}`}
												onClick={() => this.handleSetMaterialTopic('mountain')}
											>{materialTopics['mountain'].name}</button>
											<button className={`${materialTopics['country'].active ? '-active' : ''}`}
												onClick={() => this.handleSetMaterialTopic('country')}
											>{materialTopics['country'].name}</button>
											<button className={`${materialTopics['city'].active ? '-active' : ''}`}
												onClick={() => this.handleSetMaterialTopic('city')}
											>{materialTopics['city'].name}</button>
											<button className={`${materialTopics['custom'].active ? '-active' : ''}`}
												onClick={() => this.handleSetMaterialTopic('custom')}
											>{materialTopics['custom'].name}</button>
										</div>
										{
											materialTopics['custom'].active &&
											<div className="input">
												<span>收容</span>
												<input type="number"
													value={materialTopics['custom'].value}
													onFocus={() => this.handleSetMaterialTopic('custom')}
													onChange={(e) => this.handleSetMaterialCustom(e.currentTarget.value)}
												/>
												<span>天</span>
											</div>
										}
									</div>
									<div className="description -toggle toggle-material">
										＊本系統收容物資估計依據收容人數而定，系統預設最低收容人數在「鄉鎮」時為70人，在「村里」時為20人，使用者另也可自訂。
									</div>
									<div className="submit">
										<button
											disabled={!selectedCounty || !selectedTown || !isMaterialSelected}
											onClick={this.handleMaterialSubmit}
										>確定</button>
										{/* <button className="button-pink" disabled={!selectedCounty || !selectedTown || !isMaterialSelected} onClick={this.SetEstimateMaterialDTO}>下載數據結果</button> */}
										<button
											className="button-pink"
											disabled={!selectedCounty || !selectedTown || !isMaterialSelected || !isMaterialDataSubmitted || isDownloading}
											onClick={this.SetEstimateMaterialDTO}
										>
											{isDownloading && 
												<img src={spinnerGif}  className="button-spinner" />
											}
											下載數據結果
										</button>
									</div>
									{
										isMaterialAdvance &&
										<div className="advance">
											<div className="title">依需求切換不同物資</div>
											<div className="description">您也可以依照需求切換不同項目，查看所需要的數量。</div>
											{
												materialOptions &&
												materialOptions.map((option, i) =>
													<React.Fragment key={i}>
														<label className="label" htmlFor="">{option["Group_Name"]}</label>
														<div className="select">
															<CustomSelect status="normal" name={option["Category"]}
																value={`${option["Group_Name"]}-${option["current"]}`}
																onChange={value => this.handleChangeMaterialGroup(value)}>
																{
																	option["Items"].map((item, j) =>
																		<option key={j} value={`${option["Group_Name"]}-${item["Name"]}`}>{item["Name"]}</option>
																	)
																}
															</CustomSelect>
														</div>
													</React.Fragment>
												)
											}
										</div>
									}
								</div>
								<div className="result-content">
									{isDataLoading && <LoadingDots theme="red" />}
									<div className="heading">收容物資估算結果</div>
									<div className="result">
										{
											materialData &&
											materialData.map((data, i) =>
												<div className="estimate-material" key={i}>
													<div className="title">{data['Category']}</div>
													<button onClick={this.handleToggleMaterialInfo} className="info-controller"><i className="icon-plus"></i></button>
													<div className="info-list">
														<div className="list">
															{
																data["Items"].map((item, j) =>
																	(item.active === undefined || item.active) &&
																	<div className="item" key={j}>
																		<p>細項：{item["Name"]}</p>
																		<p>標準：{item["Standard"]}</p>
																	</div>
																)
															}
														</div>
													</div>
													<div className="material-list">
														{
															data["Items"].map((item, j) =>
																(item.active === undefined || item.active) &&
																<div className="item" key={j}>
																	<div className="material-item">
																		<div className="icon"><img src={`${sourceHost}/${item["Icon"]}`} alt="" /></div>
																		<div className="info">
																			<span className="name">{item["Name"]}（{item["Unit"]}）</span>
																			<span className="value">
																				{item["Value"] === -1 ?
																					<span className="type-text -en qty">-</span> :
																					<AnimatedNumber
																						className="type-text -en qty"
																						duration={300}
																						formatValue={n => transferHundredPoint(Math.floor(n))}
																						value={item["Value"]}
																					/>
																				}
																			</span>
																		</div>
																	</div>
																</div>
															)
														}
													</div>
												</div>
											)
										}
										{
											materialData &&
											<div className="material-source">
												<div className="title">參考文獻</div>
												{
													allMaterialSource.map((item, i) =>
														<div key={i} className="item" dangerouslySetInnerHTML={{ __html: item }}></div>
													)
												}
											</div>
										}
									</div>
								</div>
							</section>
						</Scroll.Element>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default EvacuationEstimate;
